import { render } from "./TaskTextArea.vue?vue&type=template&id=9613769a&scoped=true&lang=true"
import script from "./TaskTextArea.vue?vue&type=script&lang=js"
export * from "./TaskTextArea.vue?vue&type=script&lang=js"

import "./TaskTextArea.vue?vue&type=style&index=0&id=9613769a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9613769a"]])

export default __exports__